import OrderDTO from "@/dto/order/OrderDTO";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import React from "react";

interface RetailerInfoColumnProps {
    order: OrderDTO;
}

/**
 * 供货商查看代理商信息列
 */
const RetailerInfoColumn: React.FC<RetailerInfoColumnProps> = function (props) {
    const { order } = props;

    const { supplierPartnershipsStore } = useOrderManagementStore();

    const info = order.supplierDropShippingInfo;

    if (!info) {
        return <td></td>;
    }

    const retailerShopTokenExpired = order?.supplierDropShippingInfo?.retailerShopTokenExpired;
    const retailerShopId = info.retailerShopId;
    const partnership = supplierPartnershipsStore.retailerPartnershipMap.get(retailerShopId);

    return (
        <td className="ec-order-drop-shipping-info-column">
            <p>{partnership?.alias || partnership?.name}</p>
            {info.dateCreated ? (
                <p className="small text-gray">
                    推送时间:<br></br>
                    {info.dateCreated}
                </p>
            ) : null}
            {retailerShopTokenExpired ? <p className="danger">代理商店铺授权过期</p> : null}
        </td>
    );
};

export default observer(RetailerInfoColumn);
